import {
  FilterConfig,
  LocationAlarmStatus,
  StatusFilterOption,
} from '@hakimo-ui/hakimo/types';
import { LocationAlarmFilterValues } from './types';

const statusOptions: StatusFilterOption<LocationAlarmStatus>[] = [
  { id: 'pending', name: 'Pending' },
  { id: 'resolved', name: 'Resolved' },
  { id: 'inProgress', name: 'In Progress' },
];

const priorityOptions = [
  { id: 'high', name: 'High' },
  { id: 'low', name: 'Low' },
];

export const filterConfigs: FilterConfig[] = [
  {
    type: 'priority',
    defaultValue: {
      values: [],
      negative: false,
    },
    options: priorityOptions,
  },
  {
    type: 'status',
    defaultValue: {
      values: [],
      negative: false,
    },
    options: statusOptions,
  },
  {
    type: 'location',
    defaultValue: {
      values: [],
      negative: false,
    },
  },
  {
    type: 'camera',
    defaultValue: {
      values: [],
      negative: false,
    },
  },
];

const escalatedFilterConfig: FilterConfig = {
  type: 'escalated',
  label: 'Resolution',
  defaultValue: undefined,
};

/**
 * v3 only. location_alarm_v3's list endpoint implements isEscalated
 * (mirroring the Alarm Groups filter, per its own comment); v2 -- what's
 * actually deployed today -- never reads the param, so keep this out of the
 * v2 filter panel entirely rather than showing a filter that does nothing.
 */
export function getFilterConfigs(includeEscalated: boolean): FilterConfig[] {
  return includeEscalated
    ? [
        filterConfigs[0],
        filterConfigs[1],
        escalatedFilterConfig,
        ...filterConfigs.slice(2),
      ]
    : filterConfigs;
}

export const defaultFilterValues: LocationAlarmFilterValues = {
  ...filterConfigs.reduce((acc, config) => {
    return { ...acc, [config.type]: config.defaultValue };
  }, {} as LocationAlarmFilterValues),
  escalated: undefined,
};
